import PaymentKioskComponentsContainer from './PaymentKioskComponentsContainer';

export default PaymentKioskComponentsContainer;


// WEBPACK FOOTER //
// ./src/components/PaymentKioskComponentsContainer/index.jsx